module.exports = "<div class=\"container body\">\n  <div class=\"main_container\">\n    <!-- page content -->\n    <div class=\"col-md-12\">\n      <div class=\"col-middle\">\n        <div class=\"text-center text-center\">\n          <h1 class=\"error-number\">404</h1>\n          <h2>Sorry but we couldn't find this page</h2>\n        </div>\n      </div>\n    </div>\n    <!-- /page content -->\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/pages/not-found-page/not-found-page.component.html
// module id = ../../../../../src/app/pages/not-found-page/not-found-page.component.html
// module chunks = main